import { Icon } from '@chakra-ui/react';
import type { IconProps } from '@chakra-ui/react';

const IconCircleCheckFilled = (props: Omit<IconProps, 'children' | 'viewBox'>) => (
  <Icon
    fill='currentColor'
    height='100%'
    viewBox='0 0 24 24'
    width='auto'
    {...props}
  >
    <path
      d='M0 0h24v24H0z'
      fill='none'
      stroke='none'
    />
    <path d='M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z' />
  </Icon>
);

export default IconCircleCheckFilled;
